import {Box} from '@mui/material'
import CalendarMonth from '@mui/icons-material/CalendarMonth'
import theme from '../../../theme/theme'

export interface ShowAllDaysLinkProps {
  onClick?: () => void;
}

function ShowAllDaysLink({onClick}: ShowAllDaysLinkProps) {
  return (
    <Box
      style={{
        textDecoration: 'none',
        color: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <CalendarMonth fontSize="small" />
      <span style={{marginLeft: '8px'}}>Show all days</span>
    </Box>
  )
}

export default ShowAllDaysLink